import { render, staticRenderFns } from "./MonitoringCall.vue?vue&type=template&id=48785cc4&scoped=true"
import script from "./MonitoringCall.vue?vue&type=script&lang=js"
export * from "./MonitoringCall.vue?vue&type=script&lang=js"
import style0 from "./MonitoringCall.vue?vue&type=style&index=0&id=48785cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48785cc4",
  null
  
)

export default component.exports